import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { SiteContext } from '../store/siteContext';

interface AddSitesDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (selectedSiteIds: number[]) => void;
  currentSiteIds: number[];
  loading: boolean;
}

const AddSitesDialog: React.FC<AddSitesDialogProps> = ({
  open,
  onClose,
  onSubmit,
  currentSiteIds,
  loading,
}) => {
  const { t } = useTranslation();
  const { sites } = useContext(SiteContext);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  useEffect(() => {
    if (open) {
      setSelectedIds(currentSiteIds || []);
    }
  }, [open, currentSiteIds]);

  const handleToggle = (siteId: number) => {
    setSelectedIds((prev) =>
      prev.includes(siteId) ? prev.filter((id) => id !== siteId) : [...prev, siteId]
    );
  };

  const handleSave = () => {
    onSubmit(selectedIds);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('sites:t.siteAccess')}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ maxHeight: 400 }}>
            <FormControl component="fieldset" variant="standard" fullWidth>
            <FormGroup>
                {sites.map((site) => (
                <FormControlLabel
                    key={site.id}
                    control={
                    <Checkbox
                        checked={selectedIds.includes(site.id)}
                        onChange={() => handleToggle(site.id)}
                        name={site.name}
                        color="primary"
                    />
                    }
                    label={site.name}
                />
                ))}
            </FormGroup>
            </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t('common:t.cancel')}
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {t('common:t.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSitesDialog;
